import { Component, Input, HostBinding, OnChanges } from '@angular/core';

@Component({
  selector: 'app-executor',
  templateUrl: './executor.component.pug',
  styleUrls: ['./executor.component.less']
})
export class ExecutorComponent implements OnChanges {
  @Input() level;

  @HostBinding('class.skin1') skin1 = true;
  @HostBinding('class.skin2') skin2 = true;
  @HostBinding('class.skin3') skin3 = true;

  constructor() {
  }

  ngOnChanges() {
    if (!Number.isInteger(this.level)) {
      return;
    }

    this.skin1 = this.level >= 5 ? true : false;
    this.skin2 = this.level >= 10 ? true : false;
    this.skin3 = this.level >= 20 ? true : false;
  }
}
